import { render, staticRenderFns } from "./TimingHallSettings.vue?vue&type=template&id=6bf0981a&"
import script from "./TimingHallSettings.vue?vue&type=script&lang=js&"
export * from "./TimingHallSettings.vue?vue&type=script&lang=js&"
import style0 from "./TimingHallSettings.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports